// src/components/AuthLayout.jsx
import React from "react";
import "../Auth.css";

const AuthLayout = ({ title, onSubmit, children, error, rightTitle, footer }) => {
  return (
    <div className="auth-container">
      <div className="auth-left">
        <h2>{title}</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={onSubmit}>
          {children}
          <button type="submit">{title}</button>
        </form>
        {footer && <p>{footer}</p>}
      </div>
      <div className="auth-right">
        <h2>{rightTitle}</h2>
      </div>
    </div>
  );
};

export default AuthLayout;
